export default "__VITE_ASSET__BnSqIN7i__"